<template>
	<div>
		<!-- Main -->
		<nav class="uk-navbar-container uk-margin-small-bottom" uk-navbar>
			<div class="uk-navbar-left">
				<span class="uk-navbar-item uk-logo">役割マスタ</span>
			</div>
			<div class="uk-navbar-right">
				<template v-if="current_staff != null">
					<div class="navbar-item">
						<p class="uk-text-small uk-margin-right uk-margin-remove-bottom">こんにちは、{{ current_staff.display_name }}さん</p>
					</div>
				</template>
				<div class="navbar-item">
					<button class="uk-button uk-text-small uk-button-small uk-button-default" @click="clickLogoutButton">ログアウト</button>
				</div>
			</div>
		</nav>
		<div class="uk-container uk-container-expand uk-margin-medium uk-margin-remove-left uk-margin-remove-right">
			<div class="uk-align-right">
				<button class="uk-button uk-button-primary" @click="showCreateFormDialog">役割追加</button>
				<button class="uk-button uk-button-default" @click="returnButton">戻る</button>
			</div>
		</div>
		<div class="uk-container uk-container-expand uk-margin-medium uk-margin-remove-left uk-margin-remove-right">
			<table id="shop_job_position_table" class="uk-table uk-table-expand uk-table-striped">
				<thead>
				<tr>
					<th>NO.</th>
					<th>役割名</th>
					<th>表示名</th>
					<th>有効<br><span style="color: #b9e0d9">※一括選択できます</span><br><input id="bulk_check_action" class="uk-checkbox" type="checkbox" @click="bulkCheckAction"></th>
					<th>更新日</th>
					<th>編集</th>
				</tr>
				</thead>
				<tbody>
				<template v-for="(shop_job_position, index) in shop_job_positions">
					<tr class="data_row" :key="index" :data-id="shop_job_position.id">
						<td>{{ shop_job_position.id }}</td>
						<td>{{ shop_job_position.job_position.name }}</td>
						<td>{{ shop_job_position.display_name }}</td>
						<template v-if="shop_job_position.status == 0">
							<td><input class="uk-checkbox" name="status" type="checkbox" checked></td>
						</template>
						<template v-else>
							<td><input class="uk-checkbox" name="status" type="checkbox"></td>
						</template>
						<td>{{ shop_job_position.updated_at | moment }}</td>
						<td>
							<button class="uk-button uk-button-default" @click="showEditDialog(shop_job_position.id)">編集</button>
						</td>
					</tr>
				</template>
				<tr>
					<td>
						<button class="uk-button uk-button-default" @click="showCreateFormDialog">+</button>
					</td>
					<td></td>
					<td></td>
					<td></td>
					<td></td>
					<td></td>
				</tr>
				</tbody>
			</table>
			<div class="uk-container uk-container-expand uk-margin-small-bottom">
				<div class="uk-align-right">
					<button class="uk-button uk-button-primary" @click="saveEditShopJobPosition">保存</button>
				</div>
			</div>
		</div>
		<!--/ Main -->
		<!-- CreateFormDialog -->
		<div id="create_form_dialog" uk-modal>
			<div class="uk-modal-dialog uk-modal-body">
				<div class="uk-overflow-hidden">
					<div class="uk-align-left">
						<h2 class="uk-modal-title">追加</h2>
					</div>
					<div class="uk-align-right">
						<button id="create_form_dialog_close" class="uk-icon-button" type="button" uk-icon="close"></button>
					</div>
				</div>
				<form id="create_form">
					<div class="uk-form-horizontal">
						<div class="uk-margin">
							<label class="uk-form-label" for="create_form_job_position_name">役割名 (必須)</label>
							<div class="uk-form-controls">
								<select id="create_form_job_position_name" class="uk-select" name="job_position">
									<template v-for="(job_position, index) in job_positions">
										<option :key="index" :value="job_position.id">{{ job_position.name}}</option>
									</template>
								</select>
								<template v-if="typeof this.createFormState.errors.job_position_id != undefined">
									<template v-for="(error,index) in this.createFormState.errors.job_position_id">
										<p class="uk-alert-danger uk-padding-small" :key="index">{{ error }}</p>
									</template>
								</template>
							</div>
						</div>
						<div class="uk-margin">
							<label class="uk-form-label" for="create_form_display_name">表示名 (必須)</label>
							<div class="uk-form-controls">
								<input class="uk-input" id="create_form_display_name" name="display_name" type="text" placeholder="表示名を入力してください" required maxlength="8">
								<template v-if="typeof this.createFormState.errors.display_name != undefined">
									<template v-for="(error,index) in this.createFormState.errors.display_name">
										<p class="uk-alert-danger uk-padding-small" :key="index">{{ error }}</p>
									</template>
								</template>
							</div>
						</div>
						<div class="uk-margin">
							<button class="uk-width-1-1@l uk-button uk-button-large uk-button-primary" type="button" @click="saveCreateForm">追加</button>
						</div>
					</div>
				</form>
			</div>
		</div>
		<!--/ CreateFormDialog -->
		<!-- EditFormDialog -->
		<div id="edit_form_dialog" uk-modal>
			<div class="uk-modal-dialog uk-modal-body">
				<div class="uk-overflow-hidden">
					<div class="uk-align-left">
						<h2 class="uk-modal-title">編集</h2>
					</div>
					<div class="uk-align-right">
						<button id="edit_form_dialog_close" class="uk-icon-button" type="button" uk-icon="close"></button>
					</div>
				</div>
				<form id="edit_form">
					<div class="uk-form-horizontal">
						<div class="uk-margin">
							<label class="uk-form-label" for="edit_form_job_position_name">役割名 (必須)</label>
							<div class="uk-form-controls">
								<select id="edit_form_job_position_name" class="uk-select" name="job_position">
									<template v-for="(job_position, index) in job_positions">
										<option :key="index" :value="job_position.id">{{ job_position.name}}</option>
									</template>
								</select>
								<template v-if="typeof this.createFormState.errors.job_position_id != undefined">
									<template v-for="(error,index) in this.createFormState.errors.job_position_id">
										<p class="uk-alert-danger uk-padding-small" :key="index">{{ error }}</p>
									</template>
								</template>
							</div>
						</div>
						<div class="uk-margin">
							<label class="uk-form-label" for="edit_form_display_name">表示名 (必須)</label>
							<div class="uk-form-controls">
								<input class="uk-input" id="edit_form_display_name" name="display_name" type="text" placeholder="表示名を入力してください" required maxlength="8">
								<template v-if="typeof this.createFormState.errors.display_name != undefined">
									<template v-for="(error,index) in this.createFormState.errors.display_name">
										<p class="uk-alert-danger uk-padding-small" :key="index">{{ error }}</p>
									</template>
								</template>
							</div>
						</div>
						<div class="uk-margin">
							<button class="uk-width-1-1@l uk-button uk-button-large uk-button-primary" type="button" @click="saveEditForm">保存</button>
						</div>
					</div>
				</form>
			</div>
		</div>
		<!--/ EditFormDialog -->
	</div>
</template>

<script>
	import StaffAuth from '@/api/StaffAuth'
	import ShopJobPosition from '@/api/ShopJobPosition'
	import JobPosition from '@/api/JobPosition'
	import Role from '@/api/Role'
	import CallCenterAuth from '@/api/CallCenterAuth'
	import BranchOfficeAuth from '@/api/BranchOfficeAuth'
	import MainOfficeAuth from '@/api/MainOfficeAuth'

	export default {
		name: 'JobTypeMaster',
		comments: [],
		data () {
			return {
				need_confirm_alert: false,
				current_staff: null,
				job_positions: [],
				shop_job_positions: [],
				createFormState: {
					errors: []
				}
			}
		},
		filters: {
			moment: function (date) {
				return moment(date).format('YYYY/MM/DD HH:mm')
			}
		},
		methods: {
			showEditDialog: function (id) {
				$('#edit_form_dialog').data('id', id)

				let params = new URLSearchParams()
				params.append('id', id)

				ShopJobPosition.one(params).then(function (response) {
					let data = response.data.data

					$('#edit_form_job_position_name option[value="' + data.job_position.id + '"]').prop('selected', true)
					$('#edit_form_display_name').val(data.display_name)

					UIkit.modal($('#edit_form_dialog'), {container: '#app div', bgClose: false}).show()
				})
			},
			saveEditForm: function () {
				let id = $('#edit_form_dialog').data('id')

				let params = new URLSearchParams()
				params.append('id', id)
				params.append('job_position_id', $('#edit_form_job_position_name option:selected').val())
				params.append('display_name', $('#edit_form_display_name').val())

				ShopJobPosition.update(params).then(function (response) {
					alert('保存完了')
					location.reload()
				})
			},
			returnButton: function () {
				if ($('.data_row_before_save').length > 0) {
					if (window.confirm('保存されておりませんが、よろしいですか')) {
						this.$router.push('/shop')
						location.reload()
					}
				} else {
					this.$router.push('/shop')
					location.reload()
				}
			},
			clickLogoutButton () {
				let self = this

				StaffAuth.logout().then(function (response) {
					// CallCenterAuth.logout().then(function (response) {
						// BranchOfficeAuth.logout().then(function (responase) {
							// MainOfficeAuth.logout().then(function (response) {
								self.$router.push('/')
								location.reload()
							// })
						// })
					// })
				})
			},
			bulkCheckAction () {
				let checked = $('#bulk_check_action').prop('checked')
				$('#shop_job_position_table tbody .data_row [name="status"]').prop('checked', checked)
				$('#shop_job_position_table tbody .data_row').addClass('data_row_before_save')
			},
			saveEditShopJobPosition () {
				let self = this
				let length = $('#shop_job_position_table .data_row_before_save').length

				$('#shop_job_position_table .data_row_before_save').each(function (i) {
					let index = i

					let id = $(this).data('id')
					let status = 1

					if ($(this).find('[name="status"]').prop('checked')) {
						status = 0
					}

					let params = new URLSearchParams()
					params.append('id', id)
					params.append('status', status)

					ShopJobPosition.update(params).then(function () {
						if (i + 1 == length) {
							alert('保存完了')
							location.reload()
						}
					})
				})

				//	location.reload()
			},
			saveCreateForm () { // ダイアログ保存
				let self = this

				StaffAuth.current().then(function (response) {
					let staff = response.data.data
					let job_position_id = $('#create_form [name="job_position"]').val()
					let display_name = $('#create_form [name="display_name"]').val()

					let params = new URLSearchParams()
					params.append('display_name', display_name)
					params.append('job_position_id', job_position_id)
					params.append('shop_id', staff.shop_id)

					ShopJobPosition.create(params).then(function (response) {
						alert('保存完了')
						location.reload()
					}).catch(function (error) {
						self.createFormState.errors = error.response.data.errors
					})
				})
			},
			showCreateFormDialog () { // ダイアログ表示
				UIkit.modal($('#create_form_dialog'), {container: '#app div', bgClose: false}).show()
			},
			loadShopJobPositions () {
				let self = this

				StaffAuth.current().then(function (response) {
					return response.data.data
				}).then(function (staff) {
					let params = new URLSearchParams()
					params.append('shop_id', staff.shop_id)

					ShopJobPosition.all(params).then(function (response) {
						self.shop_job_positions = response.data.data
					})
				})
			},
			loadJobPositions () {
				let self = this
				let params = new URLSearchParams()
				params.append('status', 0)

				JobPosition.all(params).then(function (response) {
					self.job_positions = response.data.data
				})
			},
			registerDataChangeEvent () { // データを変更した時のイベント登録
				$(document).on('change', '#shop_job_position_table .data_row .uk-checkbox', function () {
					if ($(this).text() != $(this).data('first')) {
						$(this).closest('.data_row').addClass('data_row_before_save')
					}
				})
			}
		},
		created () {
		},
		beforeMount () {
		},
		mounted () {
			this.loadJobPositions()
			this.loadShopJobPositions()
			this.registerDataChangeEvent()

			let self = this

			Role.show().then(function (response) { // 権限取得
				let data = response.data

				if (data.data.is_admin_staff != true) { // 管理者スタッフではない場合
					self.$router.push('/')
				}
			})

			StaffAuth.current().then(function (response) {
				self.current_staff = response.data.data
			})

			$('#create_form_dialog_close').on('click', function () {
				if (self.need_confirm_alert) {
					if (window.confirm('保存されておりませんが、よろしいですか')) {
						UIkit.modal($('#create_form_dialog')).hide()
						self.need_confirm_alert = false
					}
				} else {
					UIkit.modal($('#create_form_dialog')).hide()
				}
			})

			$('#edit_form_dialog_close').on('click', function () {
				if (self.need_confirm_alert) {
					if (window.confirm('保存されておりませんが、よろしいですか')) {
						UIkit.modal($('#edit_form_dialog')).hide()
						self.need_confirm_alert = false
					}
				} else {
					UIkit.modal($('#edit_form_dialog')).hide()
				}
			})

			$('#create_form_dialog').on('change', function () {
				self.need_confirm_alert = true
			})

			$('#edit_form_dialog').on('change', function () {
				self.need_confirm_alert = true
			})
		},
		beforeRouteLeave (to, from, next) {
			$('.uk-open').remove()
			next()
		}
	}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
	#shop_job_position_table {
		thead {
			tr {
				th {
					border: solid 1px #DDD;
					text-align: center;
					vertical-align: middle;
				}
			}
		}

		tbody {
			tr {
				td {
					border: solid 1px #DDD;
					text-align: center;
					vertical-align: middle;

					&:focus {
						background: #FFF;
					}
				}
			}
		}

		.data_row_before_save {
			background: #FFFDE6;
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/page/ShopJobPositionMasterPage.vue